/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_SettingsInputs */



/**
* | output |
* | --- |
* | "Translation Settings" |
*
* @param {Translation_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_settings = /** @type {((inputs?: Translation_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungseinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de tradução")
	return /** @type {LocalizedString} */ ("Translation Settings")
});